var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReceiverList(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    rx: 6,
    fill: "#F7F9FB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.5 31.6667H34.1667V33.3333H15.8334V31.6667H17.5V17.5C17.5 17.279 17.5878 17.067 17.7441 16.9107C17.9004 16.7545 18.1124 16.6667 18.3334 16.6667H31.6667C31.8877 16.6667 32.0997 16.7545 32.256 16.9107C32.4122 17.067 32.5 17.279 32.5 17.5V31.6667ZM21.6667 24.1667V25.8333H24.1667V24.1667H21.6667ZM21.6667 20.8333V22.5H24.1667V20.8333H21.6667ZM21.6667 27.5V29.1667H24.1667V27.5H21.6667ZM25.8334 27.5V29.1667H28.3334V27.5H25.8334ZM25.8334 24.1667V25.8333H28.3334V24.1667H25.8334ZM25.8334 20.8333V22.5H28.3334V20.8333H25.8334Z",
    fill: "#85898B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReceiverList);
export default __webpack_public_path__ + "static/media/receiver-list.fa98752e.svg";
export { ForwardRef as ReactComponent };